import React, { Fragment } from 'react';
import PropertyListBrowser from './PropertyListBrowser';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_PROPERTIES_READ, ADMIN_PROPERTIES_WRITE } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const handleAdd = () => {
    historyContext.push(`/properties/new`);
  };

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_PROPERTIES_WRITE} withForbiddenPage={false}>
          <HeaderLinks onAdd={handleAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_PROPERTIES_READ}>
        <PropertyListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
